import {
	fetchPreviouslyAssignedHMSAdminSite,
	fetchPreviouslyAssignedAshCareAdminSite,
} from '../../../apiCalls/provider/shared';
import { fetchPreviouslyAssigned } from '../../../apiCalls/member/shared';
import { useQuery } from 'react-query';
import { QueryKey } from '../../../QueryKeys';

// TODO refactor this to break apart member / provider
// Get the previously assigned action items.
const usePreviouslyAssigned = (
	apiEnv,
	ssId,
	program,
	isAdmin,
	apiToken = null,
	memberId = null
) => {
	const authToken = ssId || apiToken;
	let fetchFunction;
	if (isAdmin) {
		if (ssId) {
			fetchFunction = fetchPreviouslyAssignedAshCareAdminSite;
		}
		if (apiToken) {
			fetchFunction = fetchPreviouslyAssignedHMSAdminSite;
		}
	} else if (ssId) {
		fetchFunction = fetchPreviouslyAssigned;
	}
	const {
		data: { memberProgramDetailHistory },
	} = useQuery(
		[QueryKey.GET_PREV_ASSIGNED, apiEnv, authToken, program, memberId],
		fetchFunction
	);

	// The endpoint returns the action items from all the patient's past action plans so we need to combine them all.
	const combinedHistory = memberProgramDetailHistory?.reduce(
		(allActionItems, actionPlan) => [
			...allActionItems,
			...actionPlan.actionItems,
		],
		[]
	);
	return combinedHistory;
};

export default usePreviouslyAssigned;
